import React from 'react';

import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';

interface IPropertiesFormFooter {
    disabled?: boolean;
    onDismiss: () => void;
    onSubmit: () => void;
}

const PropertiesFormFooter: React.FunctionComponent<IPropertiesFormFooter> = ({ disabled, onDismiss, onSubmit }) => (
    <div className="properties-form-footer-container">
        <PrimaryButton disabled={disabled} onClick={onSubmit} styles={{ root: { marginRight: 10 } }}>
            Salva
        </PrimaryButton>

        <DefaultButton disabled={disabled} onClick={onDismiss}>
            Annulla
        </DefaultButton>
    </div>
);

export default PropertiesFormFooter;